import { render, staticRenderFns } from "./ContractorInfoChangeHistoryDialog.vue?vue&type=template&id=55bc9da0&scoped=true&"
import script from "./ContractorInfoChangeHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./ContractorInfoChangeHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContractorInfoChangeHistoryDialog.vue?vue&type=style&index=0&id=55bc9da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc9da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
